import { render, staticRenderFns } from "./MailReactivation.vue?vue&type=template&id=586b8b27"
import script from "./MailReactivation.vue?vue&type=script&lang=ts"
export * from "./MailReactivation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports